import { useState, useEffect } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import Notification, { showToast } from '../../../components/common/notification/Notification';
import Spinner from '../../../components/common/spinner/Spinner';
import RowList from '../../components/listing/RowList';
import { Row, Col, Button, Form, InputGroup } from 'react-bootstrap';
import Pagination from '../../components/pagination/Pagination';
import PostFilter from './PostFilter';
import { Link } from "react-router";
import { IoMdAdd } from "react-icons/io"; 
import "./filter.css";

const PostListComponent = ({route}) => {
  const loggedInUser = useSelector((state) => state.auth.user);
  const assetUrl = process.env.REACT_APP_ASSET_URL;
  const token = loggedInUser?.refreshToken; 
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState(''); 
  const [filteredPosts, setFilteredPosts] = useState([]);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await axios.post(
        `${baseUrl}/property/leads`,
        {
          page_number: currentPage,
          page_size: 20,
          order_by: "ABC",         
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log('hii', response.data); 

      if (response.status === 200 && response.data.statusType === 'SUCCESS') {
        setPosts(response.data.leads || []); 
        setTotalPages(response.data.totalPage || 1);
        console.log("posts", posts);
      } else {
        showToast('Failed to fetch Post data', { type: 'error' });
      } 
    } catch (error) {
      console.error('Fetch error:', error);
      showToast('Error fetching Post data', { type: 'error' });
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async (itemId) => {
    try {
      const response = await axios.delete(
        `${baseUrl}/property/lead/delete/${itemId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.statusType === 'SUCCESS') {
        setPosts(posts.filter((item) => item.id !== itemId));
        showToast('Post deleted successfully', { type: 'success' });
      } else {
        showToast(`${response.data.text}`, { type: 'error' });
      }
    } catch (error) {
      console.error('Error deleting Post :', error);
      showToast('Error occurred during deletion', { type: 'error' });
    }
  };

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    const filtered = posts.filter(post => {
      const customerName = post.customer?.first_name?.toLowerCase() || '';
      const partnerName = post.partner?.first_name?.toLowerCase() || '';
      const description = (post.description || '').toLowerCase();
      const city = (post.city_name || '').toLowerCase();
      const state = (post.state_name || '').toLowerCase();
      const country = (post.country_name || '').toLowerCase();

      return (
        customerName.includes(term) ||
        partnerName.includes(term) ||
        description.includes(term) ||
        city.includes(term) ||
        state.includes(term) ||
        country.includes(term)
      );
    });

    setFilteredPosts(filtered);
  };

  const applyCustomFilters = (filters) => {
  const filtered = posts.filter(post => {
    return (
      (!filters.state || post.state_name === filters.state) &&
      (!filters.city || post.city_name === filters.city) &&
      (!filters.service || post.service === filters.service) &&
      (!filters.propertyType || post.property_type === filters.propertyType)
    );
  });

  setFilteredPosts(filtered);
  };

  useEffect(() => {
    fetchData();
  }, [currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (  
    <div className="algn-items-center ">
      <Notification />
      {/* <Row className="align-items-center justify-content-center my-4 mx-2">
        <Col lg={8} md={12} sm={12} className='w-100'>
          <InputGroup> 
            <Form.Control
              className='bg-white'
              placeholder="Search by name, city, state, country..."
              value={searchTerm}
              onChange={handleSearch} 
            />
            <Button variant="dark me-2">Search</Button> 
            <PostFilter posts={posts} onApply={applyCustomFilters} />
          </InputGroup>
        </Col>
          <Link
            className="btn btn-primary btn-lg w-20 my-3 "
            to="/post/add-post"
          >
            <IoMdAdd className='fs-2' />
          </Link>
      </Row> */}
      
      {/* new */}
      <Row className="my-2 px-3">
        <Col xs={12}>
          <div className="toolbar-container">

            {/* Search */}
            <InputGroup className="toolbar-search">
              <Form.Control
                placeholder="Search by name, city, state, country..."
                value={searchTerm}
                onChange={handleSearch}
                className="bg-white"
              />
              <Button variant="dark" className='me-2'>Search</Button>
              <PostFilter posts={posts} onApply={applyCustomFilters} />
            </InputGroup>

            {/* Add Button */}
            <Link to="/post/add-post" className="toolbar-add-btn">
              <IoMdAdd />
            </Link>

          </div>
        </Col>
      </Row>

      <Row className='d-flex justify-content-center'>
        <Col>
          {isLoading ? (
            <Spinner loading={true} />
          ) : (
            (() => {
              const displayPosts = (filteredPosts.length > 0 || searchTerm) ? filteredPosts : posts;
              return displayPosts.map((item) => (
                <RowList
                  key={item.id}
                  title={item.service}
                  creator={`${item.customer?.first_name || ''} ${item.customer?.last_name || ''}`}
                  CardImg={item.images?.[0]?.image_url ? assetUrl + (item.images?.[0]?.image_url ) : null}
                  createOn={item.created_on} 
                  item={item}
                  route= {route}
                  handleDelete={handleDelete}
                  // handleToggleEnable={handleToggleEnable} 
                /> 
              )); 
            })()
          )}
        </Col>
        <div className="mt-2 mb-4 d-flex justify-content-center">
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </div>
      </Row>
    </div>
  ); 
};

export default PostListComponent;
 